import { backendUri } from "@/utils/settings";
import { PCGApi } from "../services/pcg";

const getPokemonUsableItems = async (queryClient) => {
  return await queryClient.fetchQuery(
    backendUri + "api/game/ext/trainer/inventory/?usable_on_pokemon=true",
    async () => await PCGApi.Trainer.getUsableItems(),
    {
      staleTime: 1000 * 60 * 2,
      refetchOnWindowFocus: false,
    }
  );
};

const invalidatePokeUsable = (queryClient) => {
  queryClient.invalidateQueries(
    backendUri + "api/game/ext/trainer/inventory/?usable_on_pokemon=true",
  );
};

export { getPokemonUsableItems, invalidatePokeUsable };
